import joi from 'joi';

import { z } from 'zod';
import { VALID_SLUG_REGEX } from './constants';

export const boolean = joi.bool();
export const cidr = joi.string().ip({ cidr: 'required', version: ['ipv4'] });
export const cidrIpv6 = joi.string().ip({
  cidr: 'required',
  version: ['ipv6'],
});
export const ip = joi.string().ip({ cidr: 'forbidden', version: ['ipv4'] });
export const ipv6 = joi.string().ip({ cidr: 'forbidden', version: ['ipv6'] });
export const number = joi
  .string()
  .regex(/^(?:>=|>|<=|<|=)?-?[0-9]+(?:\.[0-9]+)?$/);
export const port = joi.number().min(1).max(65535);
export const string = joi.string();
export const accessList = joi.array().items(port);
export const ipFilter = joi.object().keys({ cidr, text: string }).length(1);
export const ipv6Filter = joi
  .object()
  .keys({ cidr: cidrIpv6, text: string })
  .length(1);
export const routingFilter = joi.object().keys({ ip, text: string }).length(1);
export const routingIpv6Filter = joi
  .object()
  .keys({ ip: ipv6, text: string })
  .length(1);

export const slugSchema = joi.string().regex(VALID_SLUG_REGEX).max(64);

export const slugSchemaZ = z
  .string()
  .nonempty()
  .regex(VALID_SLUG_REGEX)
  .max(64)
  .optional();
